<template>
  <div class="warper clearfix">
    <div style="height: 68px"></div>
    <div class="ArticleListBox">
      <a-row type="flex" justify="space-between">
        <a-col :span="5">
          <div class="cateBox">
            <div class="searchBox">
              <a-dropdown :trigger="['click', 'change']">
                <a-input-search
                  v-model:value="Searchvalue"
                  placeholder="搜索文档"
                  @search="onSearch"
                  @change="onChange"
                />
              </a-dropdown>
            </div>
            <div v-if="List.length > 0" style="display: relative">
              <a-menu
                class="Amenu"
                :openKeys="openKeys"
                v-model:selectedKeys="selectedKeys"
                mode="inline"
                :inlineIndent="20"
                @openChange="openChange"
              >
                <a-sub-menu v-for="first in List" :key="first.id">
                  <template slot="expandIcon"></template>
                  <template slot="title">
                    <i
                      :class="[
                        openKeys.includes(first.id)
                          ? 'iconfont icon-down'
                          : 'iconfont icon-right',
                      ]"
                    ></i>
                    {{ first.name }}
                  </template>
                  <template v-for="second in first.children">
                    <a-menu-item
                      v-if="!second.children || second.children.length == 0"
                      :key="second.id"
                    >
                      <span class="disable" v-if="second.flag == 'disable'"
                        >- {{ second.name }}</span
                      >
                      <span v-else @click="selectNode(second)"
                        >- {{ second.name }}</span
                      >
                    </a-menu-item>
                    <a-menu-item
                      v-else-if="second.children.length == 1"
                      :key="second.children[0].id"
                      @click="selectNode(second.children[0])"
                    >
                      <span class="disable" v-if="second.flag == 'disable'"
                        >- {{ second.name }}</span
                      >
                      <span v-else>- {{ second.name }}</span>
                    </a-menu-item>
                    <a-sub-menu v-else :key="second.id">
                      <template slot="title">
                        <i
                          :class="[
                            openKeys.includes(second.id)
                              ? 'iconfont icon-down'
                              : 'iconfont icon-right',
                          ]"
                        ></i>
                        {{ second.name }}
                      </template>
                      <template v-for="third in second.children">
                        <a-menu-item
                          v-if="third.children.length == 0"
                          :key="third.id"
                          @click="selectNode(third)"
                        >
                          <span class="disable" v-if="third.flag == 'disable'"
                            >- {{ third.name }}</span
                          >
                          <span v-else>- {{ third.name }}</span>
                        </a-menu-item>
                        <a-menu-item
                          v-else-if="third.children.length == 1"
                          :key="third.children[0].id"
                          @click="selectNode(third, third.children[0])"
                        >
                          <span class="disable" v-if="third.flag == 'disable'"
                            >- {{ third.name }}</span
                          >
                          <span v-else>- {{ third.name }}</span>
                        </a-menu-item>
                        <a-sub-menu v-else :key="third.id">
                          <template slot="title">
                            <i
                              :class="[
                                openKeys.includes(third.id)
                                  ? 'iconfont icon-down'
                                  : 'iconfont icon-right',
                              ]"
                            ></i>
                            {{ third.name }}
                          </template>
                          <a-menu-item
                            v-for="arti in third.children"
                            :key="arti.id"
                            @click="selectNode(arti)"
                          >
                            <span class="disable" v-if="arti.flag == 'disable'"
                              >- {{ arti.name }}</span
                            >
                            <span v-else>- {{ arti.name }}</span>
                          </a-menu-item>
                        </a-sub-menu>
                      </template>
                    </a-sub-menu>
                  </template>
                </a-sub-menu>
              </a-menu>
            </div>
          </div>
        </a-col>
        <a-col :span="19">
          <div class="breadcrumbBox">
            <!-- 面包屑 -->
            <a-breadcrumb>
              <a-breadcrumb-item>
                <i
                  class="iconfont icon-menu-home"
                  style="color: #2b6afd; margin-right: 5px"
                ></i>
                <a href="/help" class="hoverColor" style="color: #2b6afd"
                  >帮助中心</a
                ></a-breadcrumb-item
              >
              <a-breadcrumb-item v-for="item in TreeNames" :key="item">
                <span style="color: #2b6afd"> {{ item }}</span>
              </a-breadcrumb-item>
            </a-breadcrumb>
          </div>
          <div v-if="showArticleContent">
            <ArticleContent :id="articleId" :title="articleTitle" />
          </div>
          <div v-else>
            <div style="min-height: 80vh">
              <div style="padding-left: 1rem; margin-bottom: 1rem">
                <span style="color: #2b6afd; font-weight: 600"
                  >“{{ SearchvalueKey }}”</span
                >查询结果:
                <span style="color: #2b6afd; font-weight: 600">{{
                  searchList.length
                }}</span>
                篇
              </div>
              <div
                class="ListBox"
                v-for="(item, index) in searchList"
                :key="index"
                @click="selectNode(item)"
              >
                <div class="title">{{ item.title }}</div>
                <div>
                  <span v-html="item.brief"></span>
                  <span style="color: #2b6afd">【查看更多】</span>
                </div>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import ArticleContent from "@/views/ArticleContent.vue";
import { categoriesSmart, queryArticleList } from "@/utils/query.js";
import { getTreeIds, getTreeNames } from "@/utils/tool.js";

export default {
  components: {
    ArticleContent,
  },
  data() {
    return {
      id: "32d52b4948fe442ea114fa5c9cffe13c",
      Searchvalue: "",
      SearchvalueKey: "",
      openKeys: [],
      selectedKeys: [],
      replaceFields: {
        title: "name",
        key: "id",
      },
      List: [],
      breadItem: {},
      articleId: "",
      articleTitle: "",
      TreeNames: [], //被选中文章的父级目录们
      showArticleContent: true,
      searchList: [],
    };
  },
  mounted() {
    this.getCate();
  },
  activated() {
    this.initData();
  },
  methods: {
    async getCate() {
      let res = await categoriesSmart(this.id);
      this.List = [];
      if (res.code === 200) {
        this.List = res.data.directoryJson;
      }
      this.initData();
    },
    initData() {
      this.showArticleContent = true;
      let { id, SearchValue } = this.$route.query;
      if (SearchValue) {
        this.Searchvalue = SearchValue;
        this.onSearch();
        this.articleId = "";
        this.selectedKeys = [];
        this.openKeys = [];
        this.TreeNames = [];
      } else {
        this.articleId = id;
        this.selectedKeys = [id];
        this.openKeys = getTreeIds(this.List, id);
        this.TreeNames = getTreeNames(this.List, id);
        this.sentzhugePoint();
      }
    },
    selectNode(item, firstChild = {}) {
      this.articleId = item.id || String(item.g_id).split("&")[0];
      if (firstChild.id) {
        this.articleId = firstChild.id;
      }
      if (item?.title?.includes("更新说明")) {
        this.$router.push({
          name: "releaseArticle",
          query: { id },
        });
      } else {
        this.$router.push({
          path: "/smartArticleList",
          query: { id: this.articleId },
        });
      }
      this.initData();
    },
    openChange(openKeys) {
      this.openKeys = openKeys;
    },
    async onSearch() {
      if (this.Searchvalue == "") return;
      this.showArticleContent = false;
      let res = await queryArticleList(this.Searchvalue);
      let { items } = res.data.result;
      if (res.success) {
        this.searchList = [...items];
      } else {
        this.searchList = [];
      }
      this.SearchvalueKey = this.Searchvalue;
    },
    async onChange() {
      this.SearchvalueKey = this.Searchvalue;
      if (this.Searchvalue == "") {
        this.searchList = [];
        return;
      }
      this.searchList = [];
      let res = await queryArticleList(this.Searchvalue);
      let { items } = res.data.result;
      if (res.success) {
        this.searchList = [...items];
      }
    },
    sentzhugePoint() {
      let lv01 = this.TreeNames[0];
      let lv02 = this.TreeNames[1] ? this.TreeNames[1] : "";
      let lv03 = this.TreeNames[2] ? this.TreeNames[2] : "";
      this.zhugePoint("macc-help-文档中心-模块统计", {
        userid: this.GLOBAL.userid, //用户id
        lv01, //一级目录、模块
        lv02, //二级目录
        lv03, //三级目录
      });
    },
  },
};
</script>
<style scoped>
::v-deep .ant-breadcrumb-separator {
  color: #2b6afd;
}

.ArticleListBox {
  padding-top: 1rem;
}

.cateBox {
  width: 240px;
  position: fixed;
  margin-top: 1rem;
  border-radius: 5px;
  background-color: #f7f9fd;
}
.searchBox {
  padding: 1rem;
  z-index: 999;
  background-color: #f7f9fd;
}

.Amenu::-webkit-scrollbar {
  width: 5px;
}
.Amenu::-webkit-scrollbar-track {
  background: rgb(235, 234, 234);
  border-radius: 5px;
}
.Amenu::-webkit-scrollbar-thumb {
  background: rgb(199, 199, 199);
  border-radius: 5px;
}
.Amenu::-webkit-scrollbar-thumb:hover {
  background: rgb(199, 199, 199);
  border-radius: 5px;
}
.Amenu::-webkit-scrollbar-thumb:active {
  background: rgb(141, 141, 141);
  border-radius: 5px;
}

.Amenu {
  width: 240px;
  height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: transparent;
  border: none;
}
.Amenu::v-deep .ant-menu-submenu > .ant-menu {
  border: none;
  background-color: transparent;
}
.Amenu::v-deep .ant-menu-item-selected {
  border: none;
  background-color: #eaf1ff;
  border-radius: 4px;
  color: #2b6afd;
}
.Amenu::v-deep .ant-menu-submenu-selected,
.ant-menu-submenu-active,
.ant-menu-item-active {
  color: #2b6afd;
}
.Amenu::v-deep .ant-menu-submenu-title:hover {
  color: #2b6afd;
}
.Amenu::v-deep .ant-menu-item-selected::after {
  border: none;
}

.ListBox {
  padding-left: 1rem;
  padding-bottom: 2rem;
  cursor: pointer;
  position: relative;
}
.ListBox .title {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.9);
}
.disable {
  color: rgba(0, 0, 0, 0.25);
}

.breadcrumbBox {
  padding: 1rem;
}
.breadcrumbBox::v-deep .ant-breadcrumb > span:last-child {
  color: rgba(0, 0, 0, 0.45);
}
</style>
